import type { Subscription } from 'dexie'
import { liveQuery } from 'dexie'

import type { ConversationRepository } from '@src/service/worker/repository'

import { BaseService } from './base'
import type { EventService } from './event'

type UnreadCounts = Record<string, number>

export type ConversationsEvent = {
  type: 'unread changed'
  unreadCounts: UnreadCounts
}

export class ConversationService extends BaseService {
  private unreadSubscription: Subscription | null = null

  constructor(
    private conversationRepo: ConversationRepository,
    private event: EventService<ConversationsEvent>,
  ) {
    super()

    this.unreadSubscription = liveQuery(() => this.conversationRepo.unread()).subscribe(
      (unread) => {
        const unreadCounts = [...unread.keys()].reduce((final, pid) => {
          final[pid] = unread.get(pid)?.size ?? 0
          return final
        }, {} as UnreadCounts)

        this.event.dispatch({
          type: 'unread changed',
          unreadCounts,
        })
      },
    )
  }

  // FIXME: this isn't called anywhere
  tearDown() {
    this.unreadSubscription?.unsubscribe()
  }
}
